var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// node_modules/is-buffer/index.js
var require_is_buffer = __commonJS({
  "node_modules/is-buffer/index.js"(exports, module) {
    "use strict";
    module.exports = function(obj) {
      return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
    };
    function isBuffer(obj) {
      return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
    }
    function isSlowBuffer(obj) {
      return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && isBuffer(obj.slice(0, 0));
    }
  }
});

// node_modules/kind-of/index.js
var require_kind_of = __commonJS({
  "node_modules/kind-of/index.js"(exports, module) {
    "use strict";
    var isBuffer = require_is_buffer();
    var toString = Object.prototype.toString;
    module.exports = function kindOf(val) {
      if (typeof val === "undefined") {
        return "undefined";
      }
      if (val === null) {
        return "null";
      }
      if (val === true || val === false || val instanceof Boolean) {
        return "boolean";
      }
      if (typeof val === "string" || val instanceof String) {
        return "string";
      }
      if (typeof val === "number" || val instanceof Number) {
        return "number";
      }
      if (typeof val === "function" || val instanceof Function) {
        return "function";
      }
      if (typeof Array.isArray !== "undefined" && Array.isArray(val)) {
        return "array";
      }
      if (val instanceof RegExp) {
        return "regexp";
      }
      if (val instanceof Date) {
        return "date";
      }
      var type = toString.call(val);
      if (type === "[object RegExp]") {
        return "regexp";
      }
      if (type === "[object Date]") {
        return "date";
      }
      if (type === "[object Arguments]") {
        return "arguments";
      }
      if (type === "[object Error]") {
        return "error";
      }
      if (isBuffer(val)) {
        return "buffer";
      }
      if (type === "[object Set]") {
        return "set";
      }
      if (type === "[object WeakSet]") {
        return "weakset";
      }
      if (type === "[object Map]") {
        return "map";
      }
      if (type === "[object WeakMap]") {
        return "weakmap";
      }
      if (type === "[object Symbol]") {
        return "symbol";
      }
      if (type === "[object Int8Array]") {
        return "int8array";
      }
      if (type === "[object Uint8Array]") {
        return "uint8array";
      }
      if (type === "[object Uint8ClampedArray]") {
        return "uint8clampedarray";
      }
      if (type === "[object Int16Array]") {
        return "int16array";
      }
      if (type === "[object Uint16Array]") {
        return "uint16array";
      }
      if (type === "[object Int32Array]") {
        return "int32array";
      }
      if (type === "[object Uint32Array]") {
        return "uint32array";
      }
      if (type === "[object Float32Array]") {
        return "float32array";
      }
      if (type === "[object Float64Array]") {
        return "float64array";
      }
      return "object";
    };
  }
});

// node_modules/rename-keys/index.js
var require_rename_keys = __commonJS({
  "node_modules/rename-keys/index.js"(exports, module) {
    "use strict";
    (function() {
      "use strict";
      function rename2(obj, fn) {
        if (typeof fn !== "function") {
          return obj;
        }
        var res = {};
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            res[fn(key, obj[key]) || key] = obj[key];
          }
        }
        return res;
      }
      if (typeof module !== "undefined" && module.exports) {
        module.exports = rename2;
      } else {
        if (typeof define === "function" && define.amd) {
          define([], function() {
            return rename2;
          });
        } else {
          window.rename = rename2;
        }
      }
    })();
  }
});

// node_modules/deep-rename-keys/index.js
var require_deep_rename_keys = __commonJS({
  "node_modules/deep-rename-keys/index.js"(exports, module) {
    "use strict";
    var typeOf = require_kind_of();
    var rename2 = require_rename_keys();
    module.exports = function renameDeep(obj, cb) {
      var type = typeOf(obj);
      if (type !== "object" && type !== "array") {
        throw new Error("expected an object");
      }
      var res = [];
      if (type === "object") {
        obj = rename2(obj, cb);
        res = {};
      }
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          var val = obj[key];
          if (typeOf(val) === "object" || typeOf(val) === "array") {
            res[key] = renameDeep(val, cb);
          } else {
            res[key] = val;
          }
        }
      }
      return res;
    };
  }
});

// node_modules/eventemitter3/index.js
var require_eventemitter3 = __commonJS({
  "node_modules/eventemitter3/index.js"(exports, module) {
    "use strict";
    var has = Object.prototype.hasOwnProperty;
    var prefix = "~";
    function Events() {
    }
    if (Object.create) {
      Events.prototype = /* @__PURE__ */ Object.create(null);
      if (!new Events().__proto__) prefix = false;
    }
    function EE(fn, context, once) {
      this.fn = fn;
      this.context = context;
      this.once = once || false;
    }
    function EventEmitter() {
      this._events = new Events();
      this._eventsCount = 0;
    }
    EventEmitter.prototype.eventNames = function eventNames() {
      var names = [], events, name;
      if (this._eventsCount === 0) return names;
      for (name in events = this._events) {
        if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
      }
      if (Object.getOwnPropertySymbols) {
        return names.concat(Object.getOwnPropertySymbols(events));
      }
      return names;
    };
    EventEmitter.prototype.listeners = function listeners(event, exists) {
      var evt = prefix ? prefix + event : event, available = this._events[evt];
      if (exists) return !!available;
      if (!available) return [];
      if (available.fn) return [available.fn];
      for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
        ee[i] = available[i].fn;
      }
      return ee;
    };
    EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
      var evt = prefix ? prefix + event : event;
      if (!this._events[evt]) return false;
      var listeners = this._events[evt], len = arguments.length, args, i;
      if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, void 0, true);
        switch (len) {
          case 1:
            return listeners.fn.call(listeners.context), true;
          case 2:
            return listeners.fn.call(listeners.context, a1), true;
          case 3:
            return listeners.fn.call(listeners.context, a1, a2), true;
          case 4:
            return listeners.fn.call(listeners.context, a1, a2, a3), true;
          case 5:
            return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
          case 6:
            return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for (i = 1, args = new Array(len - 1); i < len; i++) {
          args[i - 1] = arguments[i];
        }
        listeners.fn.apply(listeners.context, args);
      } else {
        var length = listeners.length, j;
        for (i = 0; i < length; i++) {
          if (listeners[i].once) this.removeListener(event, listeners[i].fn, void 0, true);
          switch (len) {
            case 1:
              listeners[i].fn.call(listeners[i].context);
              break;
            case 2:
              listeners[i].fn.call(listeners[i].context, a1);
              break;
            case 3:
              listeners[i].fn.call(listeners[i].context, a1, a2);
              break;
            case 4:
              listeners[i].fn.call(listeners[i].context, a1, a2, a3);
              break;
            default:
              if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
                args[j - 1] = arguments[j];
              }
              listeners[i].fn.apply(listeners[i].context, args);
          }
        }
      }
      return true;
    };
    EventEmitter.prototype.on = function on(event, fn, context) {
      var listener = new EE(fn, context || this), evt = prefix ? prefix + event : event;
      if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
      else if (!this._events[evt].fn) this._events[evt].push(listener);
      else this._events[evt] = [this._events[evt], listener];
      return this;
    };
    EventEmitter.prototype.once = function once(event, fn, context) {
      var listener = new EE(fn, context || this, true), evt = prefix ? prefix + event : event;
      if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
      else if (!this._events[evt].fn) this._events[evt].push(listener);
      else this._events[evt] = [this._events[evt], listener];
      return this;
    };
    EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
      var evt = prefix ? prefix + event : event;
      if (!this._events[evt]) return this;
      if (!fn) {
        if (--this._eventsCount === 0) this._events = new Events();
        else delete this._events[evt];
        return this;
      }
      var listeners = this._events[evt];
      if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
          if (--this._eventsCount === 0) this._events = new Events();
          else delete this._events[evt];
        }
      } else {
        for (var i = 0, events = [], length = listeners.length; i < length; i++) {
          if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
            events.push(listeners[i]);
          }
        }
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else if (--this._eventsCount === 0) this._events = new Events();
        else delete this._events[evt];
      }
      return this;
    };
    EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
      var evt;
      if (event) {
        evt = prefix ? prefix + event : event;
        if (this._events[evt]) {
          if (--this._eventsCount === 0) this._events = new Events();
          else delete this._events[evt];
        }
      } else {
        this._events = new Events();
        this._eventsCount = 0;
      }
      return this;
    };
    EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
      return this;
    };
    EventEmitter.prefixed = prefix;
    EventEmitter.EventEmitter = EventEmitter;
    if ("undefined" !== typeof module) {
      module.exports = EventEmitter;
    }
  }
});

// node_modules/xml-lexer/dist/lexer.js
var require_lexer = __commonJS({
  "node_modules/xml-lexer/dist/lexer.js"(exports, module) {
    "use strict";
    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    var EventEmitter = require_eventemitter3();
    var noop = function noop2() {
    };
    var State = {
      data: "state-data",
      cdata: "state-cdata",
      tagBegin: "state-tag-begin",
      tagName: "state-tag-name",
      tagEnd: "state-tag-end",
      attributeNameStart: "state-attribute-name-start",
      attributeName: "state-attribute-name",
      attributeNameEnd: "state-attribute-name-end",
      attributeValueBegin: "state-attribute-value-begin",
      attributeValue: "state-attribute-value"
    };
    var Action = {
      lt: "action-lt",
      gt: "action-gt",
      space: "action-space",
      equal: "action-equal",
      quote: "action-quote",
      slash: "action-slash",
      char: "action-char",
      error: "action-error"
    };
    var Type = {
      text: "text",
      openTag: "open-tag",
      closeTag: "close-tag",
      attributeName: "attribute-name",
      attributeValue: "attribute-value"
    };
    var charToAction = {
      " ": Action.space,
      "	": Action.space,
      "\n": Action.space,
      "\r": Action.space,
      "<": Action.lt,
      ">": Action.gt,
      '"': Action.quote,
      "'": Action.quote,
      "=": Action.equal,
      "/": Action.slash
    };
    var getAction = function getAction2(char) {
      return charToAction[char] || Action.char;
    };
    var create = function create2(options) {
      var _State$data, _State$tagBegin, _State$tagName, _State$tagEnd, _State$attributeNameS, _State$attributeName, _State$attributeNameE, _State$attributeValue, _State$attributeValue2, _lexer$stateMachine;
      options = Object.assign({ debug: false }, options);
      var lexer = new EventEmitter();
      var state = State.data;
      var data = "";
      var tagName = "";
      var attrName = "";
      var attrValue = "";
      var isClosing = "";
      var openingQuote = "";
      var emit = function emit2(type, value) {
        if (tagName[0] === "?" || tagName[0] === "!") {
          return;
        }
        var event = { type, value };
        if (options.debug) {
          console.log("emit:", event);
        }
        lexer.emit("data", event);
      };
      lexer.stateMachine = (_lexer$stateMachine = {}, _defineProperty(_lexer$stateMachine, State.data, (_State$data = {}, _defineProperty(_State$data, Action.lt, function() {
        if (data.trim()) {
          emit(Type.text, data);
        }
        tagName = "";
        isClosing = false;
        state = State.tagBegin;
      }), _defineProperty(_State$data, Action.char, function(char) {
        data += char;
      }), _State$data)), _defineProperty(_lexer$stateMachine, State.cdata, _defineProperty({}, Action.char, function(char) {
        data += char;
        if (data.substr(-3) === "]]>") {
          emit(Type.text, data.slice(0, -3));
          data = "";
          state = State.data;
        }
      })), _defineProperty(_lexer$stateMachine, State.tagBegin, (_State$tagBegin = {}, _defineProperty(_State$tagBegin, Action.space, noop), _defineProperty(_State$tagBegin, Action.char, function(char) {
        tagName = char;
        state = State.tagName;
      }), _defineProperty(_State$tagBegin, Action.slash, function() {
        tagName = "";
        isClosing = true;
      }), _State$tagBegin)), _defineProperty(_lexer$stateMachine, State.tagName, (_State$tagName = {}, _defineProperty(_State$tagName, Action.space, function() {
        if (isClosing) {
          state = State.tagEnd;
        } else {
          state = State.attributeNameStart;
          emit(Type.openTag, tagName);
        }
      }), _defineProperty(_State$tagName, Action.gt, function() {
        if (isClosing) {
          emit(Type.closeTag, tagName);
        } else {
          emit(Type.openTag, tagName);
        }
        data = "";
        state = State.data;
      }), _defineProperty(_State$tagName, Action.slash, function() {
        state = State.tagEnd;
        emit(Type.openTag, tagName);
      }), _defineProperty(_State$tagName, Action.char, function(char) {
        tagName += char;
        if (tagName === "![CDATA[") {
          state = State.cdata;
          data = "";
          tagName = "";
        }
      }), _State$tagName)), _defineProperty(_lexer$stateMachine, State.tagEnd, (_State$tagEnd = {}, _defineProperty(_State$tagEnd, Action.gt, function() {
        emit(Type.closeTag, tagName);
        data = "";
        state = State.data;
      }), _defineProperty(_State$tagEnd, Action.char, noop), _State$tagEnd)), _defineProperty(_lexer$stateMachine, State.attributeNameStart, (_State$attributeNameS = {}, _defineProperty(_State$attributeNameS, Action.char, function(char) {
        attrName = char;
        state = State.attributeName;
      }), _defineProperty(_State$attributeNameS, Action.gt, function() {
        data = "";
        state = State.data;
      }), _defineProperty(_State$attributeNameS, Action.space, noop), _defineProperty(_State$attributeNameS, Action.slash, function() {
        isClosing = true;
        state = State.tagEnd;
      }), _State$attributeNameS)), _defineProperty(_lexer$stateMachine, State.attributeName, (_State$attributeName = {}, _defineProperty(_State$attributeName, Action.space, function() {
        state = State.attributeNameEnd;
      }), _defineProperty(_State$attributeName, Action.equal, function() {
        emit(Type.attributeName, attrName);
        state = State.attributeValueBegin;
      }), _defineProperty(_State$attributeName, Action.gt, function() {
        attrValue = "";
        emit(Type.attributeName, attrName);
        emit(Type.attributeValue, attrValue);
        data = "";
        state = State.data;
      }), _defineProperty(_State$attributeName, Action.slash, function() {
        isClosing = true;
        attrValue = "";
        emit(Type.attributeName, attrName);
        emit(Type.attributeValue, attrValue);
        state = State.tagEnd;
      }), _defineProperty(_State$attributeName, Action.char, function(char) {
        attrName += char;
      }), _State$attributeName)), _defineProperty(_lexer$stateMachine, State.attributeNameEnd, (_State$attributeNameE = {}, _defineProperty(_State$attributeNameE, Action.space, noop), _defineProperty(_State$attributeNameE, Action.equal, function() {
        emit(Type.attributeName, attrName);
        state = State.attributeValueBegin;
      }), _defineProperty(_State$attributeNameE, Action.gt, function() {
        attrValue = "";
        emit(Type.attributeName, attrName);
        emit(Type.attributeValue, attrValue);
        data = "";
        state = State.data;
      }), _defineProperty(_State$attributeNameE, Action.char, function(char) {
        attrValue = "";
        emit(Type.attributeName, attrName);
        emit(Type.attributeValue, attrValue);
        attrName = char;
        state = State.attributeName;
      }), _State$attributeNameE)), _defineProperty(_lexer$stateMachine, State.attributeValueBegin, (_State$attributeValue = {}, _defineProperty(_State$attributeValue, Action.space, noop), _defineProperty(_State$attributeValue, Action.quote, function(char) {
        openingQuote = char;
        attrValue = "";
        state = State.attributeValue;
      }), _defineProperty(_State$attributeValue, Action.gt, function() {
        attrValue = "";
        emit(Type.attributeValue, attrValue);
        data = "";
        state = State.data;
      }), _defineProperty(_State$attributeValue, Action.char, function(char) {
        openingQuote = "";
        attrValue = char;
        state = State.attributeValue;
      }), _State$attributeValue)), _defineProperty(_lexer$stateMachine, State.attributeValue, (_State$attributeValue2 = {}, _defineProperty(_State$attributeValue2, Action.space, function(char) {
        if (openingQuote) {
          attrValue += char;
        } else {
          emit(Type.attributeValue, attrValue);
          state = State.attributeNameStart;
        }
      }), _defineProperty(_State$attributeValue2, Action.quote, function(char) {
        if (openingQuote === char) {
          emit(Type.attributeValue, attrValue);
          state = State.attributeNameStart;
        } else {
          attrValue += char;
        }
      }), _defineProperty(_State$attributeValue2, Action.gt, function(char) {
        if (openingQuote) {
          attrValue += char;
        } else {
          emit(Type.attributeValue, attrValue);
          data = "";
          state = State.data;
        }
      }), _defineProperty(_State$attributeValue2, Action.slash, function(char) {
        if (openingQuote) {
          attrValue += char;
        } else {
          emit(Type.attributeValue, attrValue);
          isClosing = true;
          state = State.tagEnd;
        }
      }), _defineProperty(_State$attributeValue2, Action.char, function(char) {
        attrValue += char;
      }), _State$attributeValue2)), _lexer$stateMachine);
      var step = function step2(char) {
        if (options.debug) {
          console.log(state, char);
        }
        var actions = lexer.stateMachine[state];
        var action = actions[getAction(char)] || actions[Action.error] || actions[Action.char];
        action(char);
      };
      lexer.write = function(str) {
        var len = str.length;
        for (var i = 0; i < len; i++) {
          step(str[i]);
        }
      };
      return lexer;
    };
    module.exports = {
      State,
      Action,
      Type,
      create
    };
  }
});

// node_modules/xml-reader/dist/reader.js
var require_reader = __commonJS({
  "node_modules/xml-reader/dist/reader.js"(exports, module) {
    "use strict";
    var EventEmitter = require_eventemitter3();
    var Lexer = require_lexer();
    var Type = Lexer.Type;
    var NodeType = {
      element: "element",
      text: "text"
    };
    var createNode = function createNode2(params) {
      return Object.assign({
        name: "",
        type: NodeType.element,
        value: "",
        parent: null,
        attributes: {},
        children: []
      }, params);
    };
    var create = function create2(options) {
      options = Object.assign({
        stream: false,
        parentNodes: true,
        doneEvent: "done",
        tagPrefix: "tag:",
        emitTopLevelOnly: false,
        debug: false
      }, options);
      var lexer = void 0, rootNode = void 0, current = void 0, attrName = void 0;
      var reader = new EventEmitter();
      var handleLexerData = function handleLexerData2(data) {
        switch (data.type) {
          case Type.openTag:
            if (current === null) {
              current = rootNode;
              current.name = data.value;
            } else {
              var node = createNode({
                name: data.value,
                parent: current
              });
              current.children.push(node);
              current = node;
            }
            break;
          case Type.closeTag:
            var parent = current.parent;
            if (!options.parentNodes) {
              current.parent = null;
            }
            if (current.name !== data.value) {
              break;
            }
            if (options.stream && parent === rootNode) {
              rootNode.children = [];
              current.parent = null;
            }
            if (!options.emitTopLevelOnly || parent === rootNode) {
              reader.emit(options.tagPrefix + current.name, current);
              reader.emit("tag", current.name, current);
            }
            if (current === rootNode) {
              lexer.removeAllListeners("data");
              reader.emit(options.doneEvent, current);
              rootNode = null;
            }
            current = parent;
            break;
          case Type.text:
            if (current) {
              current.children.push(createNode({
                type: NodeType.text,
                value: data.value,
                parent: options.parentNodes ? current : null
              }));
            }
            break;
          case Type.attributeName:
            attrName = data.value;
            current.attributes[attrName] = "";
            break;
          case Type.attributeValue:
            current.attributes[attrName] = data.value;
            break;
        }
      };
      reader.reset = function() {
        lexer = Lexer.create({ debug: options.debug });
        lexer.on("data", handleLexerData);
        rootNode = createNode();
        current = null;
        attrName = "";
        reader.parse = lexer.write;
      };
      reader.reset();
      return reader;
    };
    var parseSync2 = function parseSync3(xml, options) {
      options = Object.assign({}, options, { stream: false, tagPrefix: ":" });
      var reader = create(options);
      var res = void 0;
      reader.on("done", function(ast) {
        res = ast;
      });
      reader.parse(xml);
      return res;
    };
    module.exports = {
      parseSync: parseSync2,
      create,
      NodeType
    };
  }
});

// node_modules/transformation-matrix/src/rotate.js
var { cos, sin, PI } = Math;

// node_modules/transformation-matrix/src/skew.js
var { tan } = Math;

// node_modules/svgson/dist/svgson.esm.js
var import_deep_rename_keys = __toESM(require_deep_rename_keys());
var import_xml_reader = __toESM(require_reader());

// node_modules/graphics-debug/dist/chunk-OB4CGOL3.js
function setStepOfAllObjects(graphics, step) {
  if (graphics.points) {
    for (const p of graphics.points) {
      p.step = step;
    }
  }
  if (graphics.lines) {
    for (const line of graphics.lines) {
      line.step = step;
    }
  }
  if (graphics.infiniteLines) {
    for (const infiniteLine of graphics.infiniteLines) {
      infiniteLine.step = step;
    }
  }
  if (graphics.polygons) {
    for (const polygon of graphics.polygons) {
      polygon.step = step;
    }
  }
  if (graphics.rects) {
    for (const rect of graphics.rects) {
      rect.step = step;
    }
  }
  if (graphics.circles) {
    for (const circle of graphics.circles) {
      circle.step = step;
    }
  }
  if (graphics.texts) {
    for (const text of graphics.texts) {
      text.step = step;
    }
  }
  return graphics;
}

// node_modules/@tscircuit/solver-utils/dist/index.js
var BaseSolver = class {
  MAX_ITERATIONS = 1e5;
  solved = false;
  failed = false;
  iterations = 0;
  progress = 0;
  error = null;
  activeSubSolver;
  failedSubSolvers;
  timeToSolve;
  stats = {};
  _setupDone = false;
  getSolverName() {
    return this.constructor.name;
  }
  setup() {
    if (this._setupDone) return;
    this._setup();
    this._setupDone = true;
  }
  /** Override this method to perform setup logic */
  _setup() {
  }
  /** DO NOT OVERRIDE! Override _step() instead */
  step() {
    if (!this._setupDone) {
      this.setup();
    }
    if (this.solved) return;
    if (this.failed) return;
    this.iterations++;
    try {
      this._step();
    } catch (e) {
      this.error = `${this.getSolverName()} error: ${e}`;
      this.failed = true;
      throw e;
    }
    if (!this.solved && this.iterations >= this.MAX_ITERATIONS) {
      this.tryFinalAcceptance();
    }
    if (!this.solved && this.iterations >= this.MAX_ITERATIONS) {
      this.error = `${this.getSolverName()} ran out of iterations`;
      this.failed = true;
    }
    if ("computeProgress" in this) {
      this.progress = this.computeProgress();
    }
  }
  /** Override this method to implement solver logic */
  _step() {
  }
  getConstructorParams() {
    throw new Error("getConstructorParams not implemented");
  }
  /**
   * Override this method to return the standardized output of the solver.
   * This method should only be called after the solver has completed successfully.
   * Returns null by default - solvers with outputs should override this method.
   */
  getOutput() {
    return null;
  }
  solve() {
    const startTime = Date.now();
    while (!this.solved && !this.failed) {
      this.step();
    }
    const endTime = Date.now();
    this.timeToSolve = endTime - startTime;
  }
  visualize() {
    return {
      lines: [],
      points: [],
      rects: [],
      circles: []
    };
  }
  /**
   * Called when the solver is about to fail, but we want to see if we have an
   * "acceptable" or "passable" solution. Mostly used for optimizers that
   * have an aggressive early stopping criterion.
   */
  tryFinalAcceptance() {
  }
  /**
   * A lightweight version of the visualize method that can be used to stream
   * progress
   */
  preview() {
    return {
      lines: [],
      points: [],
      rects: [],
      circles: []
    };
  }
};
function definePipelineStep(solverName, solverClass, getConstructorParams, opts = {}) {
  return {
    solverName,
    solverClass,
    getConstructorParams,
    onSolved: opts.onSolved
  };
}
var BasePipelineSolver = class extends BaseSolver {
  startTimeOfStage = {};
  endTimeOfStage = {};
  timeSpentOnStage = {};
  firstIterationOfStage = {};
  currentPipelineStageIndex = 0;
  inputProblem;
  /** Stores the outputs from each completed pipeline stage */
  pipelineOutputs = {};
  constructor(inputProblem) {
    super();
    this.inputProblem = inputProblem;
    this.MAX_ITERATIONS = 1e6;
  }
  _step() {
    const pipelineStageDef = this.pipelineDef[this.currentPipelineStageIndex];
    if (!pipelineStageDef) {
      this.solved = true;
      return;
    }
    if (this.activeSubSolver) {
      this.activeSubSolver.step();
      if (this.activeSubSolver.solved) {
        this.endTimeOfStage[pipelineStageDef.solverName] = performance.now();
        this.timeSpentOnStage[pipelineStageDef.solverName] = this.endTimeOfStage[pipelineStageDef.solverName] - this.startTimeOfStage[pipelineStageDef.solverName];
        const output = this.activeSubSolver.getOutput();
        if (output !== null) {
          this.pipelineOutputs[pipelineStageDef.solverName] = output;
        }
        pipelineStageDef.onSolved?.(this);
        this.activeSubSolver = null;
        this.currentPipelineStageIndex++;
      } else if (this.activeSubSolver.failed) {
        this.error = this.activeSubSolver?.error;
        this.failed = true;
        this.activeSubSolver = null;
      }
      return;
    }
    const constructorParams = pipelineStageDef.getConstructorParams(this);
    this.activeSubSolver = new pipelineStageDef.solverClass(
      ...constructorParams
    );
    this[pipelineStageDef.solverName] = this.activeSubSolver;
    this.timeSpentOnStage[pipelineStageDef.solverName] = 0;
    this.startTimeOfStage[pipelineStageDef.solverName] = performance.now();
    this.firstIterationOfStage[pipelineStageDef.solverName] = this.iterations;
  }
  solveUntilStage(stageName) {
    while (this.getCurrentStageName().toLowerCase() !== stageName.toLowerCase()) {
      this.step();
      if (this.failed || this.solved) break;
    }
  }
  getCurrentStageName() {
    return this.pipelineDef[this.currentPipelineStageIndex]?.solverName ?? "none";
  }
  getStageProgress() {
    const totalStages = this.pipelineDef.length;
    if (totalStages === 0) return 1;
    const currentStageProgress = this.activeSubSolver?.progress ?? 0;
    return (this.currentPipelineStageIndex + currentStageProgress) / totalStages;
  }
  getStageStats() {
    const stats = {};
    for (const stage of this.pipelineDef) {
      const timeSpent = this.timeSpentOnStage[stage.solverName] || 0;
      const firstIteration = this.firstIterationOfStage[stage.solverName] || 0;
      const currentIteration = this.iterations;
      const iterations = stage.solverName === this.getCurrentStageName() ? currentIteration - firstIteration : 0;
      const completed = this.currentPipelineStageIndex > this.pipelineDef.findIndex((s) => s.solverName === stage.solverName);
      stats[stage.solverName] = {
        timeSpent,
        iterations,
        completed
      };
    }
    return stats;
  }
  initialVisualize() {
    return null;
  }
  finalVisualize() {
    return null;
  }
  visualize() {
    if (!this.solved && this.activeSubSolver) {
      return this.activeSubSolver.visualize();
    }
    let stageStepOffset = 0;
    const initialVisualization = this.initialVisualize();
    if (initialVisualization) {
      setStepOfAllObjects(initialVisualization, 0);
      stageStepOffset = 1;
    }
    let finalVisualization = null;
    if (this.solved) {
      finalVisualization = this.finalVisualize();
    }
    const visualizations = [initialVisualization].filter(Boolean).concat(
      this.pipelineDef.map((stage, stageIndex) => {
        const solver = this[stage.solverName];
        const viz = solver?.visualize();
        if (!viz) return null;
        setStepOfAllObjects(viz, stageIndex + stageStepOffset);
        return viz;
      }).filter(Boolean)
    );
    if (visualizations.length === 0) {
      return { points: [], rects: [], lines: [], circles: [], texts: [] };
    }
    if (this.solved && finalVisualization) {
      setStepOfAllObjects(
        finalVisualization,
        visualizations.length + stageStepOffset + 1
      );
      visualizations.push(finalVisualization);
    }
    if (visualizations.length === 1) {
      return visualizations[0];
    }
    return {
      points: visualizations.flatMap((v) => v.points || []),
      rects: visualizations.flatMap((v) => v.rects || []),
      lines: visualizations.flatMap((v) => v.lines || []),
      circles: visualizations.flatMap((v) => v.circles || []),
      texts: visualizations.flatMap((v) => v.texts || [])
    };
  }
  preview() {
    if (this.activeSubSolver) {
      return this.activeSubSolver.preview();
    }
    return super.preview();
  }
  computeProgress() {
    return this.getStageProgress();
  }
  /**
   * Get the output from a specific pipeline stage
   */
  getStageOutput(stageOutput) {
    return this.pipelineOutputs[stageOutput];
  }
  /**
   * Get all pipeline outputs
   */
  getAllOutputs() {
    return { ...this.pipelineOutputs };
  }
  /**
   * Check if a step has completed and produced output
   */
  hasStageOutput(stageName) {
    return stageName in this.pipelineOutputs;
  }
  /**
   * Get a solver instance by name
   */
  getSolver(stageName) {
    return this[stageName];
  }
};

// lib/cross.ts
var cross = (o, a, b) => (a.x - o.x) * (b.y - o.y) - (a.y - o.y) * (b.x - o.x);

// lib/hullIdx.ts
var hullIdx = (indices, pts) => {
  const tagged = [...new Set(indices)].map((i) => {
    const pt = pts[i];
    if (!pt) return null;
    return { i, x: pt.x, y: pt.y };
  }).filter((value) => value !== null);
  tagged.sort((a, b) => a.x - b.x || a.y - b.y);
  if (tagged.length <= 2) return tagged.map((v) => v.i);
  const lower = [];
  const upper = [];
  for (const p of tagged) {
    while (lower.length >= 2) {
      const prev2 = lower[lower.length - 2];
      const prev1 = lower[lower.length - 1];
      if (!prev2 || !prev1 || cross(prev2, prev1, p) > 1e-10) break;
      lower.pop();
    }
    lower.push(p);
  }
  for (let k = tagged.length - 1; k >= 0; k--) {
    const p = tagged[k];
    if (!p) continue;
    while (upper.length >= 2) {
      const prev2 = upper[upper.length - 2];
      const prev1 = upper[upper.length - 1];
      if (!prev2 || !prev1 || cross(prev2, prev1, p) > 1e-10) break;
      upper.pop();
    }
    upper.push(p);
  }
  lower.pop();
  upper.pop();
  return lower.concat(upper).map((v) => v.i);
};

// lib/isDefined.ts
var isDefined = (value) => value !== void 0;

// lib/buildRegionsFromCells.ts
var buildRegionsFromCells = (merged) => {
  const regions = merged.cells.map(
    (cell) => cell.map((i) => merged.pts[i]).filter(isDefined)
  );
  const hulls = merged.cells.map(
    (cell) => hullIdx(cell, merged.pts).map((i) => merged.pts[i]).filter(isDefined)
  );
  return { regions, hulls };
};

// lib/BuildRegionsSolver.ts
var BuildRegionsSolver = class extends BaseSolver {
  input;
  output = null;
  constructor(input) {
    super();
    this.input = input;
  }
  _step() {
    const { regions, hulls } = buildRegionsFromCells(this.input);
    this.output = {
      pts: this.input.pts,
      validTris: this.input.validTris,
      regions,
      hulls,
      depths: this.input.depths
    };
    this.stats = { regions: regions.length };
    this.solved = true;
  }
  getConstructorParams() {
    return [this.input];
  }
  getOutput() {
    return this.output;
  }
  visualize() {
    const output = this.output;
    if (!output) {
      return { points: [], lines: [], rects: [], circles: [], texts: [] };
    }
    return {
      points: output.pts.map((pt) => ({ x: pt.x, y: pt.y, color: "#3b82f6" })),
      lines: output.regions.flatMap(
        (region) => region.flatMap((point, i) => {
          const next = region[(i + 1) % region.length];
          if (!next) return [];
          return [{ points: [point, next], strokeColor: "#0f766e" }];
        })
      ),
      rects: [],
      circles: [],
      texts: [
        {
          x: 4,
          y: 12,
          text: `regions: ${output.regions.length}`,
          color: "#1f2937"
        }
      ]
    };
  }
};

// lib/genPoints.ts
var rotatePoint = (localX, localY, rect) => {
  const cosTheta = Math.cos(rect.ccwRotation);
  const sinTheta = Math.sin(rect.ccwRotation);
  return {
    x: rect.center.x + localX * cosTheta - localY * sinTheta,
    y: rect.center.y + localX * sinTheta + localY * cosTheta
  };
};
var genPoints = (bounds, vias = [], clearance, rects = []) => {
  const points = [];
  const { minX: x0, maxX: x1, minY: y0, maxY: y1 } = bounds;
  points.push(
    { x: x0, y: y0 },
    { x: x1, y: y0 },
    { x: x1, y: y1 },
    { x: x0, y: y1 }
  );
  const edgeSegments = 10;
  for (let i = 1; i < edgeSegments; i++) {
    const t = i / edgeSegments;
    points.push({ x: x0 + t * (x1 - x0), y: y0 });
    points.push({ x: x1, y: y0 + t * (y1 - y0) });
    points.push({ x: x1 - t * (x1 - x0), y: y1 });
    points.push({ x: x0, y: y1 - t * (y1 - y0) });
  }
  const viaSegments = 24;
  for (const via of vias) {
    const radius = via.diameter / 2 + clearance;
    for (let i = 0; i < viaSegments; i++) {
      const angle = 2 * Math.PI * i / viaSegments;
      points.push({
        x: via.center.x + radius * Math.cos(angle),
        y: via.center.y + radius * Math.sin(angle)
      });
    }
  }
  for (const rect of rects) {
    const halfWidth = rect.width / 2 + clearance;
    const halfHeight = rect.height / 2 + clearance;
    const edgeSegments2 = Math.max(
      2,
      Math.ceil(Math.max(halfWidth * 2, halfHeight * 2) / 20)
    );
    for (let i = 0; i < edgeSegments2; i++) {
      const t = i / edgeSegments2;
      points.push(
        rotatePoint(-halfWidth + t * 2 * halfWidth, -halfHeight, rect)
      );
      points.push(
        rotatePoint(halfWidth, -halfHeight + t * 2 * halfHeight, rect)
      );
      points.push(rotatePoint(halfWidth - t * 2 * halfWidth, halfHeight, rect));
      points.push(
        rotatePoint(-halfWidth, halfHeight - t * 2 * halfHeight, rect)
      );
    }
  }
  return points.map((point, i) => ({
    x: point.x + (i % 7 - 3) * 1e-6,
    y: point.y + (i % 5 - 2) * 1e-6
  }));
};

// lib/GeneratePointsSolver.ts
var GeneratePointsSolver = class extends BaseSolver {
  input;
  output = null;
  constructor(input) {
    super();
    this.input = input;
  }
  _step() {
    const vias = this.input.vias ?? [];
    const rects = this.input.rects ?? [];
    this.output = {
      pts: genPoints(this.input.bounds, vias, this.input.clearance, rects)
    };
    this.stats = { points: this.output.pts.length };
    this.solved = true;
  }
  getConstructorParams() {
    return [this.input];
  }
  getOutput() {
    return this.output;
  }
  visualize() {
    const points = (this.output?.pts ?? []).map((pt) => ({
      x: pt.x,
      y: pt.y,
      color: "#2563eb"
    }));
    const vias = this.input.vias ?? [];
    return {
      points,
      lines: [],
      rects: [],
      circles: vias.map((via) => ({
        center: { x: via.center.x, y: via.center.y },
        radius: via.diameter / 2 + this.input.clearance,
        stroke: "#ef4444"
      })),
      texts: [
        {
          x: this.input.bounds.minX + 6,
          y: this.input.bounds.minY + 12,
          text: `sample points: ${points.length}`,
          color: "#1f2937"
        }
      ]
    };
  }
};

// lib/ptSegDist.ts
var ptSegDist = (p, a, b) => {
  const dx = b.x - a.x;
  const dy = b.y - a.y;
  const l2 = dx * dx + dy * dy;
  if (l2 < 1e-10) return Math.hypot(p.x - a.x, p.y - a.y);
  let t = ((p.x - a.x) * dx + (p.y - a.y) * dy) / l2;
  t = Math.max(0, Math.min(1, t));
  return Math.hypot(p.x - a.x - t * dx, p.y - a.y - t * dy);
};

// lib/concavityDepth.ts
var concavityDepth = (ring, pts) => {
  if (ring.length <= 3) return 0;
  const hull = hullIdx(ring, pts);
  const hullSet = new Set(hull);
  const hullPoints = hull.map((i) => pts[i]).filter((pt) => Boolean(pt));
  let maxDepth = 0;
  for (const index of ring) {
    if (hullSet.has(index)) continue;
    const p = pts[index];
    if (!p) continue;
    let minDistance = Number.POSITIVE_INFINITY;
    for (let i = 0; i < hullPoints.length; i++) {
      const a = hullPoints[i];
      const b = hullPoints[(i + 1) % hullPoints.length];
      if (!a || !b) continue;
      minDistance = Math.min(minDistance, ptSegDist(p, a, b));
    }
    maxDepth = Math.max(maxDepth, minDistance);
  }
  return maxDepth;
};

// lib/stitchRings.ts
var edgeKey = (a, b) => a < b ? a * 1e5 + b : b * 1e5 + a;
var stitchRings = (ringA, ringB) => {
  const edgeA = ringA.map((v, i) => [v, ringA[(i + 1) % ringA.length]]);
  const edgeB = ringB.map((v, i) => [v, ringB[(i + 1) % ringB.length]]);
  const sharedKeys = /* @__PURE__ */ new Set();
  for (const [a1, a2] of edgeA) {
    if (a2 === void 0) continue;
    for (const [b1, b2] of edgeB) {
      if (b2 === void 0) continue;
      if (a1 === b2 && a2 === b1) sharedKeys.add(edgeKey(a1, a2));
    }
  }
  if (sharedKeys.size === 0) return null;
  const remainingEdges = [];
  for (const [a1, a2] of edgeA) {
    if (a2 === void 0) continue;
    if (!sharedKeys.has(edgeKey(a1, a2))) remainingEdges.push([a1, a2]);
  }
  for (const [b1, b2] of edgeB) {
    if (b2 === void 0) continue;
    if (!sharedKeys.has(edgeKey(b1, b2))) remainingEdges.push([b1, b2]);
  }
  if (remainingEdges.length === 0) return null;
  const adjacency = /* @__PURE__ */ new Map();
  for (const [from, to] of remainingEdges) adjacency.set(from, to);
  const start = remainingEdges[0]?.[0];
  if (start === void 0) return null;
  const chain = [start];
  let current = adjacency.get(start);
  let safety = 0;
  while (current !== void 0 && current !== start && safety++ < remainingEdges.length + 5) {
    chain.push(current);
    current = adjacency.get(current);
  }
  if (current !== start || chain.length !== remainingEdges.length) return null;
  return chain;
};

// lib/mergeCells.ts
var edgeKey2 = (a, b) => a < b ? a * 1e5 + b : b * 1e5 + a;
var mergeCells = (triangles, pts, concavityTolerance) => {
  if (!triangles.length) return { cells: [], depths: [] };
  const cells = triangles.map(([a, b, c]) => {
    const pa = pts[a];
    const pb = pts[b];
    const pc = pts[c];
    if (!pa || !pb || !pc) return [a, b, c];
    return cross(pa, pb, pc) < 0 ? [a, c, b] : [a, b, c];
  });
  let changed = true;
  let iterations = 0;
  while (changed && iterations++ < 800) {
    changed = false;
    const edgeMap = /* @__PURE__ */ new Map();
    const adjacency = cells.map(() => /* @__PURE__ */ new Set());
    for (let ci = 0; ci < cells.length; ci++) {
      const ring = cells[ci];
      if (!ring) continue;
      for (let i = 0; i < ring.length; i++) {
        const current = ring[i];
        const next = ring[(i + 1) % ring.length];
        if (current === void 0 || next === void 0) continue;
        const key = edgeKey2(current, next);
        if (edgeMap.has(key)) {
          const other = edgeMap.get(key);
          if (other !== void 0) {
            adjacency[ci]?.add(other);
            adjacency[other]?.add(ci);
          }
        } else {
          edgeMap.set(key, ci);
        }
      }
    }
    let bestI = -1;
    let bestJ = -1;
    let bestRing = null;
    let bestDepth = Number.POSITIVE_INFINITY;
    for (let i = 0; i < cells.length; i++) {
      const neighbors = adjacency[i];
      if (!neighbors) continue;
      for (const j of neighbors) {
        if (j <= i) continue;
        const merged = stitchRings(cells[i] ?? [], cells[j] ?? []);
        if (!merged) continue;
        const depth = concavityDepth(merged, pts);
        if (depth <= concavityTolerance + 1e-6 && depth < bestDepth) {
          bestDepth = depth;
          bestI = i;
          bestJ = j;
          bestRing = merged;
        }
      }
    }
    if (bestI < 0 || bestJ < 0 || !bestRing) break;
    cells[bestI] = bestRing;
    cells.splice(bestJ, 1);
    changed = true;
  }
  const depths = cells.map((cell) => concavityDepth(cell, pts));
  return { cells, depths };
};

// lib/MergeCellsSolver.ts
var MergeCellsSolver = class extends BaseSolver {
  input;
  output = null;
  constructor(input) {
    super();
    this.input = input;
  }
  _step() {
    const merged = mergeCells(
      this.input.validTris,
      this.input.pts,
      this.input.concavityTolerance
    );
    this.output = {
      pts: this.input.pts,
      validTris: this.input.validTris,
      cells: merged.cells,
      depths: merged.depths
    };
    this.stats = {
      mergedCells: merged.cells.length,
      maxDepth: merged.depths.length ? Math.max(...merged.depths) : 0
    };
    this.solved = true;
  }
  getConstructorParams() {
    return [this.input];
  }
  getOutput() {
    return this.output;
  }
  visualize() {
    const cells = this.output?.cells ?? [];
    return {
      points: this.input.pts.map((pt) => ({
        x: pt.x,
        y: pt.y,
        color: "#3b82f6"
      })),
      lines: cells.flatMap(
        (cell) => cell.flatMap((index, i) => {
          const from = this.input.pts[index];
          const nextIndex = cell[(i + 1) % cell.length];
          const to = nextIndex === void 0 ? void 0 : this.input.pts[nextIndex];
          if (!from || !to) return [];
          return [{ points: [from, to], strokeColor: "#10b981" }];
        })
      ),
      rects: [],
      circles: [],
      texts: [
        {
          x: 4,
          y: 12,
          text: `merged cells: ${cells.length}`,
          color: "#1f2937"
        }
      ]
    };
  }
};

// lib/circumcircle.ts
var circumcircle = (a, b, c) => {
  const d = 2 * (a.x * (b.y - c.y) + b.x * (c.y - a.y) + c.x * (a.y - b.y));
  if (Math.abs(d) < 1e-10) return { x: 0, y: 0, r2: 1e18 };
  const a2 = a.x * a.x + a.y * a.y;
  const b2 = b.x * b.x + b.y * b.y;
  const c2 = c.x * c.x + c.y * c.y;
  const ux = (a2 * (b.y - c.y) + b2 * (c.y - a.y) + c2 * (a.y - b.y)) / d;
  const uy = (a2 * (c.x - b.x) + b2 * (a.x - c.x) + c2 * (b.x - a.x)) / d;
  return { x: ux, y: uy, r2: (a.x - ux) ** 2 + (a.y - uy) ** 2 };
};

// lib/delaunay.ts
var hasEdge = (triangle, p1, p2) => [triangle.a, triangle.b, triangle.c].includes(p1) && [triangle.a, triangle.b, triangle.c].includes(p2);
var delaunay = (rawPoints) => {
  const points = rawPoints.map((p, i) => ({ ...p, i }));
  if (points.length < 3) return [];
  let minX = Number.POSITIVE_INFINITY;
  let minY = Number.POSITIVE_INFINITY;
  let maxX = Number.NEGATIVE_INFINITY;
  let maxY = Number.NEGATIVE_INFINITY;
  for (const p of points) {
    minX = Math.min(minX, p.x);
    minY = Math.min(minY, p.y);
    maxX = Math.max(maxX, p.x);
    maxY = Math.max(maxY, p.y);
  }
  const dimension = Math.max(maxX - minX, maxY - minY) || 1;
  const midX = (minX + maxX) / 2;
  const midY = (minY + maxY) / 2;
  const s0 = {
    x: midX - 30 * dimension,
    y: midY - dimension,
    i: -1
  };
  const s1 = { x: midX, y: midY + 30 * dimension, i: -2 };
  const s2 = {
    x: midX + 30 * dimension,
    y: midY - dimension,
    i: -3
  };
  let triangles = [
    { a: s0, b: s1, c: s2, cc: circumcircle(s0, s1, s2) }
  ];
  for (const p of points) {
    const bad = triangles.filter((triangle) => {
      const dx = p.x - triangle.cc.x;
      const dy = p.y - triangle.cc.y;
      return dx * dx + dy * dy < triangle.cc.r2 + 1e-6;
    });
    const badSet = new Set(bad);
    const boundaryEdges = [];
    for (const triangle of bad) {
      const triangleEdges = [
        [triangle.a, triangle.b],
        [triangle.b, triangle.c],
        [triangle.c, triangle.a]
      ];
      for (const [ea, eb] of triangleEdges) {
        let isShared = false;
        for (const other of bad) {
          if (other === triangle) continue;
          if (hasEdge(other, ea, eb)) {
            isShared = true;
            break;
          }
        }
        if (!isShared) boundaryEdges.push([ea, eb]);
      }
    }
    triangles = triangles.filter((triangle) => !badSet.has(triangle));
    for (const [ea, eb] of boundaryEdges) {
      triangles.push({ a: ea, b: eb, c: p, cc: circumcircle(ea, eb, p) });
    }
  }
  return triangles.filter(
    (triangle) => triangle.a.i >= 0 && triangle.b.i >= 0 && triangle.c.i >= 0
  ).map((triangle) => [triangle.a.i, triangle.b.i, triangle.c.i]);
};

// lib/inFreeSpace.ts
var inFreeSpace = (px, py, bounds, vias = [], clearance, rects = []) => {
  const { minX, maxX, minY, maxY } = bounds;
  if (px < minX - 0.1 || px > maxX + 0.1 || py < minY - 0.1 || py > maxY + 0.1) {
    return false;
  }
  for (const via of vias) {
    const radius = via.diameter / 2 + clearance;
    if ((px - via.center.x) ** 2 + (py - via.center.y) ** 2 < radius * radius - 0.1) {
      return false;
    }
  }
  for (const rect of rects) {
    const halfWidth = rect.width / 2 + clearance;
    const halfHeight = rect.height / 2 + clearance;
    const dx = px - rect.center.x;
    const dy = py - rect.center.y;
    const cosTheta = Math.cos(rect.ccwRotation);
    const sinTheta = Math.sin(rect.ccwRotation);
    const localX = dx * cosTheta + dy * sinTheta;
    const localY = -dx * sinTheta + dy * cosTheta;
    if (Math.abs(localX) < halfWidth - 0.1 && Math.abs(localY) < halfHeight - 0.1) {
      return false;
    }
  }
  return true;
};

// lib/filterTris.ts
var filterTris = (triangles, pts, bounds, vias = [], clearance, rects = []) => triangles.filter(([a, b, c]) => {
  const pa = pts[a];
  const pb = pts[b];
  const pc = pts[c];
  if (!pa || !pb || !pc) return false;
  const cx = (pa.x + pb.x + pc.x) / 3;
  const cy = (pa.y + pb.y + pc.y) / 3;
  return inFreeSpace(cx, cy, bounds, vias, clearance, rects);
});

// lib/TriangulateSolver.ts
var TriangulateSolver = class extends BaseSolver {
  input;
  output = null;
  constructor(input) {
    super();
    this.input = input;
  }
  _step() {
    const vias = this.input.vias ?? [];
    const rects = this.input.rects ?? [];
    const allTriangles = delaunay(this.input.pts);
    const validTris = filterTris(
      allTriangles,
      this.input.pts,
      this.input.bounds,
      vias,
      this.input.clearance,
      rects
    );
    this.output = {
      pts: this.input.pts,
      validTris
    };
    this.stats = {
      candidateTriangles: allTriangles.length,
      validTriangles: validTris.length
    };
    this.solved = true;
  }
  getConstructorParams() {
    return [this.input];
  }
  getOutput() {
    return this.output;
  }
  visualize() {
    const triangles = this.output?.validTris ?? [];
    return {
      points: this.input.pts.map((pt) => ({
        x: pt.x,
        y: pt.y,
        color: "#2563eb"
      })),
      lines: triangles.flatMap(([a, b, c]) => {
        const pa = this.input.pts[a];
        const pb = this.input.pts[b];
        const pc = this.input.pts[c];
        if (!pa || !pb || !pc) return [];
        return [
          { points: [pa, pb], strokeColor: "#64748b" },
          { points: [pb, pc], strokeColor: "#64748b" },
          { points: [pc, pa], strokeColor: "#64748b" }
        ];
      }),
      rects: [],
      circles: [],
      texts: [
        {
          x: this.input.bounds.minX + 6,
          y: this.input.bounds.minY + 12,
          text: `valid triangles: ${triangles.length}`,
          color: "#1f2937"
        }
      ]
    };
  }
};

// lib/ConvexRegionsSolver.ts
var ConvexRegionsSolver = class extends BasePipelineSolver {
  pipelineDef = [
    definePipelineStep("generatePoints", GeneratePointsSolver, (instance) => [
      instance.inputProblem
    ]),
    definePipelineStep("triangulate", TriangulateSolver, (instance) => {
      const generated = instance.getStageOutput("generatePoints");
      if (!generated) throw new Error("generatePoints output missing");
      return [
        {
          pts: generated.pts,
          bounds: instance.inputProblem.bounds,
          vias: instance.inputProblem.vias,
          rects: instance.inputProblem.rects,
          clearance: instance.inputProblem.clearance
        }
      ];
    }),
    definePipelineStep("mergeCells", MergeCellsSolver, (instance) => {
      const triangulated = instance.getStageOutput("triangulate");
      if (!triangulated) throw new Error("triangulate output missing");
      return [
        {
          pts: triangulated.pts,
          validTris: triangulated.validTris,
          concavityTolerance: instance.inputProblem.concavityTolerance
        }
      ];
    }),
    definePipelineStep("buildRegions", BuildRegionsSolver, (instance) => {
      const merged = instance.getStageOutput("mergeCells");
      if (!merged) throw new Error("mergeCells output missing");
      return [merged];
    })
  ];
  getConstructorParams() {
    return [this.inputProblem];
  }
  getOutput() {
    return this.getStageOutput("buildRegions") ?? null;
  }
  visualize() {
    const result = this.getOutput();
    if (!result) {
      return { points: [], lines: [], rects: [], circles: [], texts: [] };
    }
    return {
      points: result.pts.map((pt) => ({
        x: pt.x,
        y: pt.y,
        color: "#38b6ff"
      })),
      lines: result.regions.flatMap(
        (region) => region.map((p, i) => {
          const next = region[(i + 1) % region.length] ?? p;
          return {
            points: [
              { x: p.x, y: p.y },
              { x: next.x, y: next.y }
            ],
            strokeColor: "#4ecb82"
          };
        })
      ),
      rects: [],
      circles: (this.inputProblem.vias ?? []).map((via) => ({
        center: { x: via.center.x, y: via.center.y },
        radius: via.diameter / 2,
        stroke: "#ff6b6b"
      })),
      texts: [
        {
          x: this.inputProblem.bounds.minX + 8,
          y: this.inputProblem.bounds.minY + 16,
          text: `regions=${result.regions.length}`,
          color: "#ffffff"
        }
      ]
    };
  }
};

// lib/computeConvexRegions.ts
var isDefinedPoint = (value) => value !== void 0;
var computeConvexRegions = (input) => {
  const { bounds, clearance, concavityTolerance } = input;
  const vias = input.vias ?? [];
  const rects = input.rects ?? [];
  const pts = genPoints(bounds, vias, clearance, rects);
  const allTriangles = delaunay(pts);
  const validTris = filterTris(
    allTriangles,
    pts,
    bounds,
    vias,
    clearance,
    rects
  );
  const { cells, depths } = mergeCells(validTris, pts, concavityTolerance);
  const regions = cells.map(
    (cell) => cell.map((i) => pts[i]).filter(isDefinedPoint)
  );
  const hulls = cells.map(
    (cell) => hullIdx(cell, pts).map((i) => pts[i]).filter(isDefinedPoint)
  );
  return {
    pts,
    validTris,
    regions,
    hulls,
    depths
  };
};

// lib/dist2.ts
var dist2 = (a, b) => (a.x - b.x) ** 2 + (a.y - b.y) ** 2;

// lib/computeRegionPorts.ts
var computeRegionPorts = (regions, bounds, vias, clearance) => {
  const result = [];
  for (let regionIndex = 0; regionIndex < regions.length; regionIndex++) {
    const region = regions[regionIndex];
    if (!region) continue;
    for (let i = 0; i < region.length; i++) {
      const a = region[i];
      const b = region[(i + 1) % region.length];
      if (!a || !b) continue;
      const mx = (a.x + b.x) / 2;
      const my = (a.y + b.y) / 2;
      const onBoundary = Math.abs(mx - bounds.minX) < 1 || Math.abs(mx - bounds.maxX) < 1 || Math.abs(my - bounds.minY) < 1 || Math.abs(my - bounds.maxY) < 1;
      const nearVia = vias.some(
        (via) => dist2(via.center, { x: mx, y: my }) < (via.diameter / 2 + clearance + 2) ** 2
      );
      if (!onBoundary || nearVia) {
        const segmentLength = Math.sqrt(dist2(a, b));
        const pointsOnSegment = Math.max(1, Math.floor(segmentLength / 40));
        for (let k = 0; k < pointsOnSegment; k++) {
          const t = (k + 1) / (pointsOnSegment + 1);
          result.push({
            x: a.x + t * (b.x - a.x),
            y: a.y + t * (b.y - a.y),
            region: regionIndex
          });
        }
      }
    }
  }
  return result;
};

// lib/polyArea.ts
var polyArea = (ring) => {
  let signedArea2 = 0;
  for (let i = 0; i < ring.length; i++) {
    const current = ring[i];
    const j = (i + 1) % ring.length;
    const next = ring[j];
    if (!current || !next) continue;
    signedArea2 += current.x * next.y - next.x * current.y;
  }
  return Math.abs(signedArea2) / 2;
};

// lib/regionPath.ts
var regionPath = (region) => `${region.map((p, i) => `${i === 0 ? "M" : "L"}${p.x.toFixed(2)},${p.y.toFixed(2)}`).join(" ")} Z`;
export {
  BuildRegionsSolver,
  ConvexRegionsSolver,
  GeneratePointsSolver,
  MergeCellsSolver,
  TriangulateSolver,
  buildRegionsFromCells,
  computeConvexRegions,
  computeRegionPorts,
  concavityDepth,
  cross,
  delaunay,
  dist2,
  filterTris,
  genPoints,
  hullIdx,
  inFreeSpace,
  isDefined,
  mergeCells,
  polyArea,
  ptSegDist,
  regionPath,
  stitchRings
};
/*! Bundled license information:

is-buffer/index.js:
  (*!
   * Determine if an object is a Buffer
   *
   * @author   Feross Aboukhadijeh <https://feross.org>
   * @license  MIT
   *)

deep-rename-keys/index.js:
  (*!
   * deep-rename-keys <https://github.com/jonschlinkert/deep-rename-keys>
   *
   * Copyright (c) 2015 Jon Schlinkert, contributors.
   * Licensed under the MIT license.
   *)
*/
